import { SectionWithVerticalSpacing } from '@insify/components';
import { pageIntroContent } from '@insify/css/classes.module.css';
import { LogoWithText } from '@insify/design-system/logo';
import { textMd, textSm } from '@insify/design-system/typography';
import { useBreakpoint } from '@insify/react-hooks';
import clsx from 'clsx';

import { WizardLayoutForm } from '../../components/WizardLayoutForm';

import * as styles from './Confirmation.module.css';

import type React from 'react';

type ConfirmationProps = {
  Header?: React.ComponentType<{ className: string }>;
  nextStepsHeader?: string;
  nextSteps: {
    icon: React.ReactElement;
    body: React.ReactNode;
  }[];
  // Todo clean up, rename props or make separate composable components; add it to the showcase
  slotBetweenNextStepsAndLogo?: React.ReactNode;
  logo?: React.ComponentType<{ className?: string }>;
  slotAfterLogo?: React.ReactNode;
  illustration?: React.ReactElement;
};

/** To adjust background for mobile --branding-color-background */
export const Confirmation = ({
  Header,
  nextStepsHeader,
  nextSteps,
  slotBetweenNextStepsAndLogo,
  logo,
  slotAfterLogo,
  illustration,
}: ConfirmationProps) => {
  const isMobile = !useBreakpoint('(min-width: 960px)');
  const hasCustomLogo = logo !== undefined;
  const Logo = logo ?? LogoWithText;

  return (
    <div className={styles.container}>
      <WizardLayoutForm isBackHidden={true} isForwardHidden={true}>
        <SectionWithVerticalSpacing>
          {illustration}
          {Header && <Header className={styles.body} />}
          <h3 className={clsx(textMd, styles.nextStepsHeader, pageIntroContent)}>{nextStepsHeader}</h3>
          <ol className={styles.nextSteps}>
            {nextSteps.map((step, index) => (
              <li key={index} className={styles.nextStepItem}>
                {step.icon}
                <span className={textSm}>{step.body}</span>
              </li>
            ))}
          </ol>
          {slotBetweenNextStepsAndLogo ? slotBetweenNextStepsAndLogo : null}
          {isMobile || hasCustomLogo ? (
            <Logo className={clsx(styles.logo, hasCustomLogo && styles.customLogo)} />
          ) : null}
          {slotAfterLogo ? slotAfterLogo : null}
        </SectionWithVerticalSpacing>
      </WizardLayoutForm>
    </div>
  );
};
